<template>
  <section class="overview">
    <div class="max-w-4xl mx-auto px-4 py-12">
      <div class="grid md:grid-cols-2 gap-8 items-center">

        <div id="overview-imgs">
          <div class="relative lg:mt-4 lg:mb-12">
            <div class="flex gap-2">

              <!-- Left image -->
              <div class="mt-8 w-1/2">
                <img
                  src="@/assets/images/home/program1.png"
                  alt="Training facility"
                  class="w-full h-96 object-cover"
                />
              </div>
            
              <!-- Right image -->
              <div class="w-1/2">
                <img
                  src="@/assets/images/home/program2.png"
                  alt="Training facility"
                  class="w-full h-96 object-cover"
                />
              </div>
            </div>

            <!-- Logo overlay -->
            <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-full p-1 shadow-md">
              <img
                src="@/assets/images/logo-empire-oc-black.png"
                alt="Empire Training logo"
                class="w-20 h-20"
              />
            </div>
          </div>
        </div>

        <div id="overviewText">
          <div class="space-y-6">
            <h2 class="text-4xl font-bold leading-tight italic">
              LET'S FIND YOUR PATH TO <span class="underline">EXCELLENCE</span>
            </h2>
            <p>
              Whether you're looking to master a martial art, build strength, or discover a supportive fitness community, your journey starts here. Choose any program for your free trial class and experience the difference firsthand.
            </p>
            <div>
              <ButtonLink 
                text="our locations"
                url="/locations"
                color="white"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
      
<script>
import ButtonLink from '../Common/ButtonLink.vue'

export default {
  name: 'ExcellencePath',
  components: {
    ButtonLink
  }
}
</script>
